import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { NbDialogRef, NbGlobalPhysicalPosition, NbToastrService } from "@nebular/theme";
import { CsvExportParams, GridApi } from "ag-grid-community";

@Component({
  selector: "ngx-csv",
  templateUrl: "./csv.component.html",
  styleUrls: ["./csv.component.scss"]
})
export class CsvComponent implements OnInit {

  gridApi: GridApi;
  fileName = "";
  useBom = true;
  showLabel = true;

  options: CsvExportParams = {
    suppressQuotes: false,
    columnGroups: true,
    columnSeparator: ',',
    skipHeader: !this.showLabel
  };

  constructor(
    public dialogRef: NbDialogRef<CsvComponent>,
    private toastrService: NbToastrService
  ) { }

  ngOnInit() { }

  export(): void {
    const csvBody: string = this.gridApi.getDataAsCsv(this.options);

    if (!csvBody) {
      this.toastrService.show("저장할 내용이 없습니다.", "확인",
        {
          status: "warning",
          duration: 1000,
          position: NbGlobalPhysicalPosition.TOP_LEFT
        }
      );
      return;
    }

    const now: string = new DatePipe("en-US").transform(
      new Date(),
      "yyyyMMddHHmmss"
    );

    this.downloadFile(csvBody, `${this.fileName}_${now}.csv`, this.useBom);
    this.dialogRef.close(true);
  }

  exportToClipboard() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.gridApi.getDataAsCsv(this.options);
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.toastrService.success('클립보드로 복사되었습니다.', '안내 메시지');
    this.dialogRef.close(true);
  }

  checkedBom(): void {
    this.useBom = !this.useBom;
  }

  checkedShowLabel(): void {
    this.showLabel = !this.showLabel;
    this.options.skipHeader = !this.showLabel;
  }

  private downloadFile(data: string, filename: string, useBom: boolean) {
    const blobBody = useBom ? ['\ufeff', data] : [data];
    const blob = new Blob(blobBody, { type: 'application/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
}
